import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetWhoIndicatesLink,
	GetWhoIndicatesLinkModel,
	GetWhoIndicatesLinkParams,
} from 'domain/usecases/private/home/who-indicates';

export class RemoteWhoIndicatesLink implements GetWhoIndicatesLink {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetWhoIndicatesLinkModel>,
	) {}

	async get(params?: GetWhoIndicatesLinkParams): Promise<GetWhoIndicatesLinkModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
